import { useEffect, useState } from "react";

import { fetchThumbnailManifest } from "./fetchThumbnailManifest";
import { generateSignedUrl } from "./generatePreSignedUrl";
import { parseM3u8ForLastThumbnail } from "./m3u8Parser";

import type { Cookie } from "@spwn/types/functions";

/** サムネイルURL取得のポーリング間隔（ミリ秒） */
const POLLING_INTERVAL_MS = 5000;

export const useGetVideoThumbnailPresignedUrl = ({
  url: cookieUrl,
  cookie,
}: Pick<Cookie, "url" | "cookie">): string | undefined => {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      try {
        const thumbnailManifestFileData = await fetchThumbnailManifest({
          cookie: { url: cookieUrl, cookie },
        });

        if (thumbnailManifestFileData === undefined) {
          return;
        }

        const lastFileName = parseM3u8ForLastThumbnail(
          thumbnailManifestFileData
        );

        if (!lastFileName) {
          console.warn("No last thumbnail file name found.");
          return;
        }

        const lastThumbnailUrl = generateSignedUrl({
          manifestFileUrl: cookieUrl,
          cookie,
          fileName: lastFileName,
        });

        setThumbnailUrl(lastThumbnailUrl);
      } catch (error) {
        console.error("error happened in useGetPresignedUrl", error);
      }
    };
    // 初回実行
    void fetchData();

    // ポーリング実行
    const intervalId = setInterval(() => {
      void fetchData();
    }, POLLING_INTERVAL_MS);

    // クリーンアップ
    return () => clearInterval(intervalId);
  }, [cookieUrl, cookie]);

  return thumbnailUrl;
};
